import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PeptideCalculator from "@/pages/PeptideCalculator";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<PeptideCalculator />} />
        </Routes>
        <Toaster theme="dark" position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
